import { forwardRef } from 'react';
import PropTypes from 'prop-types';

export const IconMapPin = forwardRef(({ width, height, className }, ref) => {
	return (
		<svg
			ref={ref}
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			className={className}
			viewBox="0 0 46 53.287">
			<defs>
				<filter
					id="Subtraction_1"
					x="0"
					y="0"
					width={width}
					height={height}
					filterUnits="userSpaceOnUse">
					<feOffset dy="3" input="SourceAlpha" />
					<feGaussianBlur stdDeviation="3" result="blur" />
					<feFlood floodColor="#91191c" floodOpacity="0.2" />
					<feComposite operator="in" in2="blur" />
					<feComposite in="SourceGraphic" />
				</filter>
			</defs>
			<g
				transform="matrix(1, 0, 0, 1, 0, 0)"
				filter="url(#Subtraction_1)">
				<path
					id="Subtraction_1-2"
					data-name="Subtraction 1"
					d="M-2670-1532.713h0c-.866-.906-1.727-1.789-2.561-2.644-6.138-6.293-11.438-11.728-11.438-18.561a14.034,14.034,0,0,1,4.1-9.959A13.868,13.868,0,0,1-2670-1568a14.057,14.057,0,0,1,14,14.082c0,6.91-5.387,12.4-11.624,18.767l-.026.026c-.767.782-1.56,1.591-2.349,2.41Zm.5-26.218a5.506,5.506,0,0,0-5.5,5.5,5.506,5.506,0,0,0,5.5,5.5,5.506,5.506,0,0,0,5.5-5.5A5.506,5.506,0,0,0-2669.5-1558.931Z"
					transform="translate(2693 1574)"
					fill="#91191c"
				/>
			</g>
		</svg>
	);
});

IconMapPin.propTypes = {
	color: PropTypes.string,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

IconMapPin.defaultProps = {
	color: '#91191c',
	width: '46',
	height: '53.287'
};

IconMapPin.displayName = 'IconMapPin';
